export const AppHostServiceEventOriginator = "AppHostService" as const;
